var CONFUSEDWEBSITE = CONFUSEDWEBSITE || {},
    CSSCONSTANTS = CSSCONSTANTS || {};

(function (factory) {
    if (typeof define === 'function' && define.amd) {
        define(function (require) {
            factory(require('jquery'));
        });
    } else {
        factory(window.jQuery);
    }
})(function ($) {

    CONFUSEDWEBSITE.setupMobileNav = function () {

        enquire.register(CSSCONSTANTS.mobileHeaderMaxWidthMQ, {
            match: function () {

                if (!$('.' + CSSCONSTANTS.mobileNavClass).length) {
                    CONFUSEDWEBSITE.createMobileNav();
                }

            }
        });
    };

    CONFUSEDWEBSITE.createMobileNav = function () {

        var $page = $('.' + CSSCONSTANTS.pageClass),
			$globalNavCategories = $('.' + CSSCONSTANTS.globalNavCategoryClass),

			$mobileNav = $('<nav/>', {
			    'class': CSSCONSTANTS.mobileNavClass
			}),

			$mobileNavCategories = $('<ul/>', {
			    'class': CSSCONSTANTS.mobileNavCategoriesClass
			}),

            $mobileNavQuickLinks = $('.mobile-nav__quick-links'),
			$helpLink = $('.' + CSSCONSTANTS.globalNavHelpClass),
			helpLinkHref = $helpLink.attr('href'),
			helpLinkText = $helpLink.text(),

			$mobileNavHelpCategory = $('<li />', {
			    'class': CSSCONSTANTS.mobileNavCategoryClass + ' ' + CSSCONSTANTS.mobileNavCategoryHelpClass
			}),

			$mobileNavHelpLink = $('<a />', {
			    'class': CSSCONSTANTS.mobileNavCategoryLinkClass,
			    href: helpLinkHref,
			    text: helpLinkText
			}),

			$globalHeaderMasthead = $('.' + CSSCONSTANTS.globalHeaderMastheadClass),

			$mobileNavToggle = $('<div />', {
			    'class': CSSCONSTANTS.mobileNavToggleClass
			}),

			$mobileNavToggleLink = $('<a />', {
			    href: '#',
			    text: 'Menu'
			});

        $.each($globalNavCategories, function () {
            var $this = $(this),
				$thisCategoryLink = $this.find('.' + CSSCONSTANTS.globalNavCategoryLinkClass),
				thisCategoryText = $thisCategoryLink.text(),
                thisCategoryHref = $thisCategoryLink.attr('href'),
                thisCategoryGACategory = $thisCategoryLink.attr('data-ga-click-category'),
                thisCategoryGA = $thisCategoryLink.attr('data-ga-click-label'),
				$thisCategorySubcategories = $this.find('.' + CSSCONSTANTS.globalNavSubCategoryClass),
				$mobileNavCategory = $('<li/>', {
				    'class': CSSCONSTANTS.mobileNavCategoryClass
				}),
				$mobileNavCategoryLink = $('<a/>', {
				    'class': CSSCONSTANTS.mobileNavCategoryLinkClass,
				    href: '#',
				    'data-ga-click-category': thisCategoryGACategory,
				    'data-ga-click-label' : thisCategoryGA,
				    text: thisCategoryText
				}),
				$mobileNavCategorySubcategories = $('<nav/>', {
				    'class': CSSCONSTANTS.mobileNavSubCategoriesClass
				}),
				$mobileNavCategorySubcategoriesContainer = $('<div/>', {
				    'class': CSSCONSTANTS.mobileNavSubCategoriesContainerClass
				}),
				 $mobileNavCloseCategory = $('<a/>', {
				     'class': CSSCONSTANTS.mobileNavCloseClass,
				     href: '#',
				     text: 'Back'
				 }),

				$mobileSubcategoriesHeading = $('<strong/>', {
				    'class': CSSCONSTANTS.mobileNavSubCategoriesHeadingClass
				}),
				$mobileSubcategoriesHeadingLink = $('<a/>', {
				    href: thisCategoryHref,
				    text: thisCategoryText
				});

            $mobileNavCloseCategory.appendTo($mobileNavCategorySubcategoriesContainer);
            $mobileSubcategoriesHeadingLink.appendTo($mobileSubcategoriesHeading);
            $mobileSubcategoriesHeading.appendTo($mobileNavCategorySubcategoriesContainer);

            $.each($thisCategorySubcategories, function () {
                var $this = $(this),
                    thisHeading = $this.find('.' + CSSCONSTANTS.globalNavSubcategoryHeaderClass).text(),
                    $thisSubCategoryList = $this.find('.' + CSSCONSTANTS.globalNavSubcategoryContentsClass),
                    $thisItems = $this.find('.' + CSSCONSTANTS.globalNavSubcategoryContentsItemClass + ' a'),

                    $mobileSubcategoryHeading = $('<strong/>', {
                        'class': CSSCONSTANTS.mobileNavSubcategoryHeadingClass,
                        text: thisHeading
                    }),

                    $mobileSubcategoryContents = $('<ul />', {
                        'class': CSSCONSTANTS.mobileNavSubcategoryContentsClass
                    });

                if ($thisSubCategoryList.hasClass(CSSCONSTANTS.globalNavSubcategoryContentsProminentClass)) {
                    $mobileSubcategoryContents.addClass(CSSCONSTANTS.mobileNavSubcategoryContentsClass + '--prominent');
                }

                $.each($thisItems, function () {
                    var $this = $(this),
                        thisHref = $this.attr('href'),
                        thisCategoryGACategory = $thisCategoryLink.attr('data-ga-click-category'),
                        thisGA = $this.attr('data-ga-click-label'),
                        thistext = $this.text(),
                        $mobileSubcategoryContentsItem = $('<li/>', {
                            'class': CSSCONSTANTS.mobileNavSubcategoryContentsItemClass
                        }),
                        $mobileSubcategoryContentsItemLink = $('<a/>', {
                            href: thisHref,
                            text: thistext,
                            'data-ga-click-category': thisCategoryGACategory,
                            'data-ga-click-label': thisGA
                        });

                    $mobileSubcategoryContentsItemLink.appendTo($mobileSubcategoryContentsItem);
                    $mobileSubcategoryContentsItem.appendTo($mobileSubcategoryContents);
                });


                $mobileSubcategoryHeading.appendTo($mobileNavCategorySubcategoriesContainer);
                $mobileSubcategoryContents.appendTo($mobileNavCategorySubcategoriesContainer);
            });


            $mobileNavCategoryLink.appendTo($mobileNavCategory);
            $mobileNavCategorySubcategoriesContainer.appendTo($mobileNavCategorySubcategories);
            $mobileNavCategorySubcategories.appendTo($mobileNavCategory);
            $mobileNavCategory.appendTo($mobileNavCategories);

        });

        $mobileNavQuickLinks.appendTo($mobileNav);

        $mobileNavHelpLink.appendTo($mobileNavHelpCategory);
        $mobileNavHelpCategory.appendTo($mobileNavCategories);

        $mobileNavCategories.appendTo($mobileNav);

        $mobileNav.insertAfter($page);

        $mobileNavToggleLink.appendTo($mobileNavToggle);
        $mobileNavToggle.appendTo($globalHeaderMasthead);

        CONFUSEDWEBSITE.activateMobileNav();
    };

    CONFUSEDWEBSITE.activateMobileNav = function () {
        $('.' + CSSCONSTANTS.mobileNavToggleClass + ' a').on('click',function (e) {
            $('.' + CSSCONSTANTS.mobileNavClass).toggleClass(CSSCONSTANTS.mobileNavOpenClass);
            $('.' + CSSCONSTANTS.pageClass).toggleClass(CSSCONSTANTS.mobileNavOpenClass);
            e.preventDefault();
        });

        $('.' + CSSCONSTANTS.mobileNavCategoryLinkClass).on('click',function (e) {
            var $mobileCategorySubcategories = $(this).next('.' + CSSCONSTANTS.mobileNavSubCategoriesClass);

            if ($mobileCategorySubcategories.length) {
                e.preventDefault();
                $mobileCategorySubcategories.addClass(CSSCONSTANTS.mobileNavSubCategoriesOpenClass);
            }
        });

        $('.' + CSSCONSTANTS.mobileNavCloseClass).on('click',function (e) {
            e.preventDefault();
            $(this).closest('.' + CSSCONSTANTS.mobileNavSubCategoriesClass).removeClass(CSSCONSTANTS.mobileNavSubCategoriesOpenClass);
        });
    };

});